import Parse from "parse";
import { useEffect, useState } from "react";
import { Wheelchair_Accessible } from "../js/parsegenerated";

export function useWheelchairAccessible() {
  const [wca, setWCA] = useState<Wheelchair_Accessible[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Wheelchair_Accessible).find().then(setWCA);
  }, [reload]);

  return [
    wca,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Wheelchair_Accessible[], () => void];
}
